import { KrakendCollection, PagedResults } from "../models/generics";
import client from "./axios";

const redisVariablesUrl = `${window.__env.KRAKEND_URL}/v1/redis`;

export enum RedisVariableType {
  JSON = 'JSON',
  String = 'string',
}
export type RedisVariable = {
  namespace: string;
  key: string;
  value: string;
  type?: RedisVariableType;
}

export const RedisVariables = {
  getRedisVariables: (params?: URLSearchParams) => client.get<PagedResults<RedisVariable | KrakendCollection<RedisVariable>>>(`${redisVariablesUrl}`, { params }),
  getNamespaces: () => client.get<string[]>(`${redisVariablesUrl}/namespaces`),
  createRedisVariable: (body: RedisVariable) => client.post<string[]>(`${redisVariablesUrl}`, body),
  deleteRedisVariable: (key: string, namespace?: string) => client.delete<any>(`${redisVariablesUrl}/${namespace || "-"}/${key}`),
  getRedisVariable: (key: string, namespace?: string) => client.get<RedisVariable>(`${redisVariablesUrl}/${namespace || "-"}/${key}`),
  updateRedisVariable: (body: RedisVariable) => client.put<RedisVariable>(`${redisVariablesUrl}`, body),
}